import { Link } from 'react-router-dom';

const BG_IMAGE =
  'https://storage.readdy-site.link/project_files/ef2cd86a-0c8c-43d9-a80f-76980d5cdfeb/ab262791-f958-4d5f-9668-382cabd18e3d_Background-Logo.png?v=fb679531d6310f06ab4c803570d880d6';

export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-screen flex items-center overflow-hidden"
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 w-full h-full"
        style={{
          backgroundImage: `url("${BG_IMAGE}")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
        }}
      />

      {/* Dark overlay for text contrast */}
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(135deg, rgba(0,26,77,0.78) 0%, rgba(0,40,104,0.72) 40%, rgba(0,61,153,0.65) 70%, rgba(26,82,184,0.60) 100%)',
        }}
      />

      {/* ── Foreground content ── */}
      <div className="relative w-full max-w-5xl mx-auto px-8 py-32 text-center" style={{ zIndex: 2 }}>
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-red-400/50 bg-red-600/20 text-red-200 text-xs font-semibold uppercase tracking-widest mb-6">
          <i className="ri-dna-fill" />
          10 Years of Regenerative Medicine Excellence
        </div>
        <h1
          className="text-5xl md:text-6xl font-bold text-white leading-tight mb-6"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Your Trusted Partner in<br />Regenerative Medicine
        </h1>
        <p className="text-lg text-blue-100 max-w-3xl mx-auto mb-10 leading-relaxed">
          OnPoint USA brings over a decade of expertise and an extensive network of connections in the Regenerative Medicine field. We equip healthcare professionals, clinics, and medical spas with the tools, resources, and industry relationships needed to excel in this rapidly evolving space.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/manufacturing-and-distribution"
            className="px-7 py-3 border-2 border-white text-white font-semibold rounded-md hover:bg-white hover:text-blue-900 transition-all duration-200 cursor-pointer whitespace-nowrap text-sm"
          >
            Manufacturing and Distribution
          </Link>
          <Link
            to="/contact-us"
            className="px-7 py-3 bg-red-600 text-white font-semibold rounded-md hover:bg-red-700 transition-all duration-200 cursor-pointer whitespace-nowrap text-sm"
          >
            Contact Us
          </Link>
        </div>
      </div>
    </section>
  );
}
